import * as o from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Tray.es.js";
const r = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(t, { ref: e, ...a, weights: m }));
r.displayName = "TrayIcon";
const n = r;
export {
  n as Tray,
  r as TrayIcon
};
